/* unplugin-vue-components disabled */import script from "./FilePreviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FilePreviewModal.vue?vue&type=script&setup=true&lang=js"

import "./FilePreviewModal.vue?vue&type=style&index=0&id=7e7da25d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e7da25d"]])

export default __exports__